/* block */
window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-16586792740');

/* block */
gtag('config', 'AW-16586792740/h3bJCKHWgNEcEKS-meU9', {
    'phone_conversion_number': '09 873 6364'
  });

/* block */
(function() {
  var winzFired = false;
  function fireWinzLeadEvent() {
    if (winzFired) return;
    winzFired = true;
    if (typeof gtag !== "undefined") {
      gtag("event", "conversion", {
        send_to: 'AW-16586792740/PRK_CIaJp4scEKS-meU9',
        value: 100.0,
        currency: 'NZD'
      });
    }
    if (typeof fbq !== "undefined") {
      fbq('track', 'Lead', {
        value: 100,
        currency: 'NZD',
        content_name: 'WINZ Quote Request'
      });
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.indexOf("/apps/request-quote") === 0) {
      fireWinzLeadEvent();
      return;
    }
    if (window.location.pathname.indexOf("/pages/winz") === 0) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              var qqForm = node.querySelector && (
                node.querySelector('form[action*="request-quote"]') ||
                node.querySelector(".quote-form") ||
                node.querySelector('[class*="request-quote"] form')
              );
              if (qqForm || (node.tagName === "FORM" && (node.action || "").indexOf("request-quote") > -1)) {
                fireWinzLeadEvent();
                observer.disconnect();
              }
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { observer.disconnect(); }, 30000);
    }
  });
})();

/* block */
(function() {
  var fFired = false;
  function fireFranchiseLead() {
    if (fFired) return; fFired = true;
    if (typeof gtag !== "undefined") {
      gtag("event", "conversion", { send_to: 'AW-16586792740/3ucoCLfokcEcEKS-meU9' });
    }
    if (typeof fbq !== "undefined") {
      fbq('track', 'Lead', { content_name: 'Franchise Enquiry', content_category: 'Franchise' });
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.indexOf("/pages/franchise-thank-you") === 0) {
      fireFranchiseLead();
    }
  });
})();
